/**
 * Backend hata objesini kullanici dilinde mesaja cevirir.
 * Yeni format: { error_code, message_tr, message_en, ... }
 * Legacy format: { detail: "string" }
 * FastAPI otomatik 422 format: { detail: [{ type, loc, msg, ... }, ...] } —
 * Pydantic field_validator/model_validator'dan fırlatılan ValueError'lar
 * (özel HTTPException DEĞİL) bu şekle düşer; eskiden bu dizi `typeof === 'object'`
 * kontrolünü geçip message_tr/message_en aranıyor ama bulunamayıp sessizce
 * axios'un jenerik "Request failed with status code 422" mesajına düşüyordu
 * (coordinator bulgusu — preview-count'un yeni "filters zorunlu" 422'si).
 */
export function getApiErrorMessage(err, lang = 'tr') {
  const detail = err?.response?.data?.detail;

  if (Array.isArray(detail) && detail.length > 0) {
    const msgs = detail.map((d) => d?.msg).filter(Boolean);
    if (msgs.length > 0) return msgs.join('; ');
  }

  if (detail && typeof detail === 'object' && !Array.isArray(detail)) {
    const msg = detail[`message_${lang}`] || detail.message_en || detail.message_tr;
    if (msg) return msg;
  }

  if (typeof detail === 'string') return detail;

  if (err?.message) return err.message;

  return lang === 'tr' ? 'Bilinmeyen bir hata oluştu' : 'An unknown error occurred';
}

/**
 * Hata objesinden error_code'u dondurur (varsa).
 */
export function getApiErrorCode(err) {
  const detail = err?.response?.data?.detail;
  if (detail && typeof detail === 'object') return detail.error_code || null;
  return null;
}
